import { HTMLAttributes, ReactNode } from 'react'

import ArrowDownIcon from '@wwt/shared/assets/icons/outline/arrow-down.svg'

import { cn } from '@/shared/lib/cn'

export const Block = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => {
	return (
		<div
			className={cn('flex max-w-[35rem] flex-col gap-y-1', className)}
			{...props}
		></div>
	)
}

interface BlockItemProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
	title: ReactNode
	value: ReactNode
}

export const Item = ({ title, value, className, ...props }: BlockItemProps) => {
	return (
		<article
			className={cn('ts-6 flex justify-between gap-y-2', className)}
			{...props}
		>
			<h2>{title}</h2>
			<div className={cn('min-w-20 text-right')}>{value}</div>
		</article>
	)
}

interface CollapsibleTitleProps
	extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
	isOpen: boolean
	title: ReactNode
}

export const CollapsibleTitle = ({
	isOpen,
	title,
	...props
}: CollapsibleTitleProps) => {
	return (
		<article
			className="flex items-center gap-x-2"
			{...props}
		>
			<ArrowDownIcon
				className={cn(
					'w-4 rotate-0 transition-all duration-100',
					isOpen && 'rotate-180'
				)}
			/>
			<h2>{title}</h2>
		</article>
	)
}
